package ui.composables

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun preloadImages(
    resources: List<DrawableResource>,
): androidx.compose.runtime.State<Boolean> {
    var loaded by remember { mutableStateOf(0) }

    resources.forEach { res ->
        val painter = painterResource(res)

        DisposableEffect(painter) {
            loaded++
            onDispose { }
        }
    }

    return remember {
        derivedStateOf { loaded >= resources.size }
    }
}